import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Control } from 'shared/components/fields/control';
import { TextInputWrapper } from 'shared/components/fields/text';
import { HeatingControlType } from 'console/climatic/setting-tabs/type';
import { SettingCard } from 'z3k-settings/components/material-utils/settings-card';
import { useEditingProps } from 'z3k-settings/components/utils/unpack-props';
import { useCallback, useContext } from 'react';
import { MaterialDropdown } from 'shared/components/fields';
import { ControlWithoutValidation } from 'shared/components/fields/control/without-validation';
import { Z3KSettingsEditor } from 'z3k-settings/provider/types';
import { HeatingCircuit } from 'z3k-config';
import { getPumpId, getSensorId, getTapId } from 'console/climatic/utils/getters';
export function HeatingCard({ number, heating_settings }) {
    const { replace_config, config } = useContext(Z3KSettingsEditor);
    const nameEditingProps = useEditingProps(heating_settings.id, 'heating_circuits', 'name');
    const heating_control_type_options = [
        { text: 'Прямой', value: HeatingControlType.DIRECT },
        { text: 'Смесительный', value: HeatingControlType.MIX },
        { text: 'Отключен', value: HeatingControlType.OFF },
    ];
    const type_field = useCallback((input_props) => (_jsx(MaterialDropdown, { options: heating_control_type_options, ...input_props })), [heating_control_type_options]);
    const onChangeType = (new_value) => {
        replace_config(HeatingCircuit.get.modifyById(config, heating_settings.id, (circuit) => {
            switch (new_value) {
                case HeatingControlType.OFF:
                    return {
                        ...HeatingCircuit.setEnabled(circuit, false),
                        name: heating_settings.name,
                        control_devices: [],
                        water_temp_sensor: null,
                    };
                case HeatingControlType.DIRECT:
                    return {
                        ...HeatingCircuit.setEnabled(circuit, true),
                        name: heating_settings.name,
                        control_devices: [
                            getPumpId(config.object_arrays, config.pumps, circuit.id),
                        ],
                        water_temp_sensor: getSensorId(config.object_arrays, config.analog_temperature_sensors?.map((sens) => sens.id), circuit.id) ?? null,
                    };
                case HeatingControlType.MIX:
                    return {
                        ...HeatingCircuit.setEnabled(circuit, true),
                        name: heating_settings.name,
                        control_devices: [
                            getPumpId(config.object_arrays, config.pumps, circuit.id),
                            getTapId(config.object_arrays, config.threeway_taps, circuit.id),
                        ],
                        water_temp_sensor: getSensorId(config.object_arrays, config.analog_temperature_sensors?.map((sens) => sens.id), circuit.id) ?? null,
                    };
            }
        }));
    };
    return (_jsxs(SettingCard, { title: `Контур отопления №${number}`, container_props: {
            gridTemplateColumns: 'repeat(auto-fill, minmax(235px, 1fr))',
        }, children: [_jsx(Control, { label: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435", ...nameEditingProps, field: TextInputWrapper, help_id: null }), _jsx(ControlWithoutValidation, { label: "\u0422\u0438\u043F", value: heating_settings.control_type, onChange: onChangeType, field: type_field, help_id: null })] }));
}
